// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"8f00651d","453":"07497f96","610":"3fd5096d"}[chunkId] + ".chunk.js";
};